import styled from 'styled-components';
import { Heading } from '@/components/Heading';

export const OuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-large);
  width: 100%;
  max-width: 469px;
`;

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-large);
  width: 100%;

  @media (width >= 48rem) {
    padding-inline: var(--spacing-large);
  }
`;

export const DetailsHeading = styled(Heading)`
  display: none;

  @media (width >= 48rem) {
    display: block;
    width: 100%;
    padding: var(--spacing-large);
    background: var(--grey-100);
    font-size: var(--font-size-text-xl);
    font-weight: var(--font-weight-medium);
    color: var(--brand-900);
  }
`;
